import { withUnconnectedRegularConnectionAtAllTimes } from "./brick-initializer-helpers";

/**
 * Initialize the given audience brick
 * @param {JourneyBrick} brick
 */
const initialize = brick => {
    const _registerConnection = brick.registerConnection;
    brick.registerConnection = function(connection) {
        //https://datanext.atlassian.net/browse/DPN-3188
        //Detect incoming connection by comparing sourceBrickIds - audience bricks don't allow incoming connections 
        if(connection.sourceBrickId !== brick.id) {
            connection.delete();
            return;
        }

        return _registerConnection.apply(this, arguments);
    }

    withUnconnectedRegularConnectionAtAllTimes(brick);
};

export {
    initialize
}